const csrfToken = () =>
  document.querySelector('meta[name="csrf-token"]')?.content;

export const handleResponse = async (response, returnStatusCode) => {
  if (!response.ok) {
    const errorResponse = await response.json(); // Deserialize error details
    const errorMessages = {};
    // Iterate through the error response and extract error messages
    for (const fieldError of Object.keys(errorResponse)) {
      const fieldErrors = errorResponse[fieldError];
      if (Array.isArray(fieldErrors)) {
        errorMessages[fieldError] = fieldErrors.map((error) => error.error);
      }
    }
    throw errorMessages;
  }

  if (returnStatusCode) {
    return response.status; // Return the HTTP status code
  } else {
    const responseBody = await response.text();
    if (responseBody.trim() !== '') {
      const responseData = JSON.parse(responseBody); // Deserialize the JSON response data
      return responseData;
    }
  }

  return false;
};

export const get = async (queryPath) => {
  try {
    const res = await fetch(queryPath, {
      headers: {
        'Content-Type': 'application/json',
      },
    });

    if (!res.ok) {
      throw `GET ${res.status} ${res.url}`;
    }

    return res.json();
  } catch (err) {
    throw new Error(err);
  }
};

export const patch = async (queryPath, body) => {
  try {
    const res = await fetch(queryPath, {
      method: 'PATCH',
      headers: {
        'Content-Type': 'application/json',
        'X-CSRF-Token': csrfToken(),
      },
      body: JSON.stringify(body),
    });

    if (!res.ok) {
      throw `PATCH ${res.status} ${res.url}`;
    }

    return res.bodyUsed && res.json();
  } catch (err) {
    throw new Error(err);
  }
};

export const patchWithResponse = async (
  url,
  data,
  returnStatusCode = false
) => {
  try {
    const response = await fetch(url, {
      method: 'PATCH',
      headers: {
        'Content-Type': 'application/json',
        'X-CSRF-Token': csrfToken(),
      },
      body: JSON.stringify(data),
    });

    return handleResponse(response, returnStatusCode);
  } catch (err) {
    throw new Error(err);
  }
};

export const put = async (url, data, returnStatusCode = false) => {
  try {
    const response = await fetch(url, {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
        'X-CSRF-Token': csrfToken(),
      },
      body: JSON.stringify(data),
    });
    return handleResponse(response, returnStatusCode);
  } catch (error) {
    throw new Error(error);
  }
};

export const post = async (queryPath, body) => {
  try {
    const res = await fetch(queryPath, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-CSRF-Token': csrfToken(),
      },
      body: JSON.stringify(body),
    });

    if (!res.ok) {
      throw `POST ${res.status} ${res.url}`;
    }

    return res.json();
  } catch (err) {
    throw new Error(err);
  }
};

export const remove = async (queryPath) => {
  try {
    const res = await fetch(queryPath, {
      method: 'DELETE',
      headers: {
        'Content-Type': 'application/json',
        'X-CSRF-Token': csrfToken(),
      },
    });

    if (!res.ok) {
      throw `POST ${res.status} ${res.url}`;
    }
  } catch (err) {
    throw new Error(err);
  }
};

export const removeWithResponse = async (queryPath, body) => {
  try {
    const res = await fetch(queryPath, {
      method: 'DELETE',
      headers: {
        'Content-Type': 'application/json',
        'X-CSRF-Token': csrfToken(),
      },
      body: JSON.stringify(body),
    });

    if (!res.ok) {
      throw `POST ${res.status} ${res.url}`;
    }
    return res.json();
  } catch (err) {
    throw new Error(err);
  }
};

export const getStatus = async (queryPath) => {
  try {
    const res = await fetch(queryPath, {
      headers: {
        'Content-Type': 'application/json',
      },
    });
    return res.status;
  } catch (err) {
    throw new Error(err);
  }
};
